/**
 * is dom element
 * @return {Boolean} Lets you know if a letiable is a dom element or not
 */
__.isDomElement = function(el) {
  return el instanceof Element;
}
